import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EditCustomerReutilizableComponent } from './edit-customer-reutilizable.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';
import { EditCustomerComponent } from '../edit-customer/edit-customer.component';
import { DxSelectBoxModule, DxTextBoxModule, DxTextAreaModule, DxFormModule, DxAutocompleteModule, DxAccordionModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxPopupModule, DxScrollViewModule, DxNumberBoxModule, DxDateBoxModule, DxTagBoxModule, DxTooltipModule } from 'devextreme-angular';
import { NewContactComponent } from 'src/app/shared/new-contact/new-contact.component';
import { NewContactModule } from 'src/app/shared/new-contact/new-contact.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DinamicModalModule } from 'src/app/shared/dinamic-modal/dinamic-modal.module';
import { CreateUpdateActivityDinamicModule } from '../../home/my-activity/create-update-activity-dinamic/create-update-activity-dinamic.module';


@NgModule({
  declarations: [
    EditCustomerReutilizableComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DashboardModule,
    DxDataGridModule,
    DxButtonModule,
    DxCheckBoxModule,
    NewContactModule,
    DxScrollViewModule,
    DxPopupModule,
    DxAccordionModule,
    DxAutocompleteModule,
    DxFormModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxTagBoxModule,
    DxNumberBoxModule,
    GooglePlaceModule,
    DxDateBoxModule,
    DinamicModalModule,
    CreateUpdateActivityDinamicModule,
    DxTooltipModule
  ],
  exports: [EditCustomerReutilizableComponent],
  entryComponents: [NewContactComponent]
})
export class EditCustomerReutilizableModule { }
